module.exports = __webpack_public_path__ + "static/30-d6b42660ca5a3f905e2a0775da2096c8.jpg";